import clsx from 'clsx';
import React from 'react';

import Button from '@/src/components/common/Elements/Button/Button';
import { EmailEntryFiles } from '@/src/components/project/Inbox2/types';
import { useCompleteListPagination } from '@/src/hooks/useListCompletePagination';

import AttachmentItem from '../../../../Attachments/AttachmentItem/AttachmentItem';

const ATTACHMENTTS_LIMIT = 10;

type AttachmentsProps = {
  inboxEntryId: number;
  className?: string;
  onSetEmailFileEntry: (emailFileEntry: any) => void;
  isSentEmailType: boolean;
  preloadedEmailFileEntries?: EmailEntryFiles;
  isReadonly?: boolean;
};

const Attachments = ({
  inboxEntryId,
  onSetEmailFileEntry,
  className,
  preloadedEmailFileEntries,
  isSentEmailType,
  isReadonly = false,
}: AttachmentsProps) => {
  const {
    loadMore,
    hasMore,
    paginatedList: allFiles,
  } = useCompleteListPagination({
    list: preloadedEmailFileEntries.list,
    maxPerPage: ATTACHMENTTS_LIMIT,
  });

  return (
    <React.Fragment>
      <div className={className}>
        {allFiles.map((emailFileEntry, index) => (
          <AttachmentItem
            key={`${emailFileEntry.emailId}_${index}`}
            emailFileEntry={emailFileEntry}
            inboxEntryId={inboxEntryId}
            onClick={() => onSetEmailFileEntry(emailFileEntry)}
            isReadonly={isReadonly}
            isSentEmailType={isSentEmailType}
          />
        ))}
        {hasMore && (
          <React.Fragment>
            <div className={clsx('container--loadMore', 'tw-w-full tw-text-center', 'tw-p-[10px]')}>
              <Button
                className={clsx(
                  'tw-text-cfo-blue-600 tw-font-brandonTextMedium tw-underline',
                  'tw-m-0',
                  'hover:tw-underline'
                )}
                onClick={loadMore}
              >
                Load More
              </Button>
            </div>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

export default Attachments;
